import { ArrowEvent, MarkerEvent } from '@/types/event';
import { NestedObject } from '@/types/object';
import { SelectedVideoIds } from '@/types/video';

export const getVideoIdsFromEvent = (event: NestedObject): SelectedVideoIds => ({
  eventId: String(event['event.eventId']),
  videoEventId: String(event['event.attributes.originatingArqamEventId'] || event['event.attributes.arqamEventId']),
});

export const getVideoIdsFromEvents = (events: NestedObject[]) => events.map(getVideoIdsFromEvent);

const getVideoIdsFromEventMarker = (event: MarkerEvent | ArrowEvent): SelectedVideoIds => ({
  eventId: event.eventId,
  videoEventId: event.videoEventId || '',
});

export const getVideoIdsFromEventMarkers = (events: (MarkerEvent | ArrowEvent)[]) =>
  events.map(getVideoIdsFromEventMarker);
